import type {PureAction} from '@travel-frontend/state-handling-sdk';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_LEADS_STATE = 'uiState/leads/SET_LEADS_STATE';

export const setLeadsConfirmedState = (id: number): PureAction => {
  return {
    type: PURE(SET_LEADS_STATE),
    id
  };
};
